<script setup>
import BaseText from "@/library/BaseText.vue";

const props = defineProps({
  color: {
    type: String,
    default: "blue",
    validator: (value) =>
      ["blue", "green", "red", "yellow", "purple", "orange"].includes(value),
  },
});
</script>

<template>
  <div
    class="base-progress-tag"
    :class="`base-progress-tag--${props.color}`"
  >
    <div class="base-progress-tag__icon"></div>
    <BaseText
      variant="caption-semibold"
      as="div"
      class="base-progress-tag__text"
    >
      <slot />
    </BaseText>
  </div>
</template>

<style lang="scss" scoped>
.base-progress-tag {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  padding: 10px 12px;

  &__icon {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: relative;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 10px;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      z-index: -1;
      animation: ping 2.3s cubic-bezier(0, 0, 0.2, 1) infinite;
      opacity: 0.3;
      background-color: inherit;
    }
  }

  &__text {
    font-weight: 700;
  }

  &--blue {
    background-color: $color-ui-foam-blue-15;
  }

  &--blue &__icon {
    background-color: $color-ui-foam-blue;
  }

  &--orange {
    background-color: $color-ui-cloaked-15;
  }

  &--orange &__icon {
    background-color: $color-ui-cloaked;
  }

  &--green {
    background-color: rgba($color-ui-safe-zone-green, 0.15);
  }

  &--green &__icon {
    background-color: $color-ui-safe-zone-green;

    &::before {
      background-color: rgba($color-ui-safe-zone-green, 0.3);
    }
  }
}

@keyframes ping {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0.6;
  }

  50%,
  100% {
    transform: translate(-50%, -50%) scale(2);
    opacity: 0;
  }
}
</style>
